import api from '@/services/api'
import Vue from 'vue'

const state = {
  all: [],
  current: { users: [], sites: [], indicatorFormulas: [], siteTags: [] },
  selected: { users: [], sites: [], indicatorFormulas: [], siteTags: [] },
  editFeedback : { show: false }
}

// getters
const getters = {}

// actions
const actions = {
  list ({ commit }) {
    return new Promise( (resolve) => {
      api().get('/customers').then( (response) => {
        commit('list', response.data.data);
        resolve(response.data.data)
      });
    })
  },
  get ({ commit }, guid) {
    return new Promise( (resolve) => {
      api().get('/customers/' + guid).then( (response) => {
        commit('current', response.data.data);
        resolve(response.data.data)
      })
    })
  },
  refresh ({ commit, state }) {
    return new Promise( (resolve) => {
      api().get('/customers/' +  state.selected.guid).then( (response) => {
        commit('selected', response.data.data);
        resolve(response.data.data)
      })
    })
  },
  add ({ commit }, data) {
    return new Promise((resolve, reject) => {
       api().post('/customer/new', data).then((response) => {
        commit('current', response.data.data);
        resolve(response.data.data)
       })
    })
  },
  edit ({ commit }, data) {
    return new Promise((resolve, reject) => {
       api().post('/customer', data).then((response) => {
        commit('current', response.data.data);
        resolve(response.data.data)
       })
    })
  },
  delete ({ commit }, guid) {
    return new Promise( (resolve) => {
      api().post('/customer/' + guid + '/delete').then((response) => {
        resolve()
       })
    })
  },
  getEnerpClientId({ commit }, vat_code) {
    return new Promise((resolve) => {
      api().get(`/customer/enerp-client-id?vat_code=${vat_code}`).then((response) => {
        resolve(response.data)
      })
    })
  },
  /*indicators({ commit }) {
    return new Promise( (resolve) => {
      api().post('/customer/indicators').then((response) => {
        resolve(response.data.data)
       })
    })
  }*/
}

// mutations
const mutations = {
  list (state, customers) {
    state.all = customers
  },
  current (state, current) {
    state.current = current
  },
  selected (state, selected) {
    if(selected != null)
      state.selected = selected
  },
  reset (state) {
    state.current = { users: [], sites: [] }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/customers.js